import { useState } from 'react';
import HackCard from '../components/HackCard';
import FilterBar from '../components/FilterBar';
import SectionHead from '../components/SectionHead';
import devHacks from '../data/devHacks';
import styles from './DevHacksPage.module.css';

export default function DevHacksPage() {
  const categories = ['All', ...new Set(devHacks.map(h => h.category))];
  const [active, setActive] = useState('All');

  const filtered = active === 'All'
    ? devHacks
    : devHacks.filter(h => h.category === active);

  return (
    <div>
      {/* ── HERO ── */}
      <div className={styles.hero}>
        <div className="container">
          <div className={styles.heroInner}>
            <span className={styles.heroEmoji}>⚡</span>
            <h1 className={styles.heroTitle}>Dev Hacks</h1>
            <p className={styles.heroSub}>
              Quick code tips that make you go "why didn't I know this earlier".
              One-click copy on every snippet.
            </p>
          </div>

          {/* Stats strip */}
          <div className={styles.statsStrip}>
            {[
              ['⚡', devHacks.length,        'Total Hacks'],
              ['📋', 'One-click',             'Copy All Code'],
              ['🏷',  categories.length - 1,  'Categories'],
              ['🆓',  'Always',               'Free to use'],
            ].map(([e, n, l]) => (
              <div key={l} className={styles.stripStat}>
                <span className={styles.stripE}>{e}</span>
                <span className={styles.stripN}>{n}</span>
                <span className={styles.stripL}>{l}</span>
              </div>
            ))}
          </div>

          {/* Filter */}
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32 }}>
            <FilterBar
              categories={categories}
              active={active}
              onChange={setActive}
              dark
            />
          </div>
        </div>
      </div>

      {/* ── GRID ── */}
      <div className={`container ${styles.gridWrap}`}>
        <SectionHead
          title={`${active === 'All' ? 'All' : active} Hacks`}
          sub={`${filtered.length} snippet${filtered.length !== 1 ? 's' : ''} - click Copy to grab any one.`}
        />

        <div className={styles.grid}>
          {filtered.map((hack, i) => (
            <HackCard
              key={hack.id}
              hack={hack}
              style={{ animationDelay: `${i * 0.06}s` }}
            />
          ))}
        </div>
      </div>

      {/* ── SUBMIT CTA ── */}
      <div className={styles.submitBanner}>
        <div className="container">
          <div className={styles.submitInner}>
            <div>
              <h3 className={styles.submitTitle}>Got a hack to share?</h3>
              <p className={styles.submitSub}>
                Send me your favourite code tip - I'll credit you if I feature it.
              </p>
            </div>
            <a
              href="mailto:hello@codetocrumbs.com?subject=Dev Hack Submission"
              className="btn-primary"
            >
              Submit a Hack ✦
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
